import { Tooltip, Typography } from '@material-ui/core';
import { Inline, Stack } from '@superdispatch/ui';
import { TextBox } from '@superdispatch/ui-lab';
import { useMemo } from 'react';
import { VehicleConditionIcon } from 'shared/ui/VehicleConditionIcon';
import {
  formatVehicleTitle,
  PostingTransportType,
  PostingVehicleDTO,
} from '../../data/dto/PostingLoadDTO';
import { PostingVehicleDimensions } from './PostingVehicleDimensions';

interface PostingVehiclesSummaryProps {
  title: string;
  vehicles: PostingVehicleDTO[];
  transportType: PostingTransportType;
  hideVehicleInfo?: boolean;
}

export function PostingVehiclesSummary({
  title,
  vehicles,
  transportType,
  hideVehicleInfo = false,
}: PostingVehiclesSummaryProps) {
  const hasInoperable = useMemo(
    () => vehicles.some(({ is_inoperable }) => is_inoperable),
    [vehicles],
  );
  return (
    <Inline space="xxsmall" verticalAlign="center">
      <Tooltip
        enterDelay={800}
        title={
          <Stack space="xxsmall">
            {vehicles.map((vehicle) => (
              <Stack key={vehicle.guid}>
                <Inline verticalAlign="center">
                  <TextBox color="white">
                    {formatVehicleTitle(vehicle, { hideVehicleInfo })}
                  </TextBox>

                  <VehicleConditionIcon
                    isInoperable={vehicle.is_inoperable}
                    transportType={transportType}
                  />
                </Inline>

                {vehicles.length === 1 && (
                  <PostingVehicleDimensions color="white" vehicle={vehicle} />
                )}
              </Stack>
            ))}
          </Stack>
        }
      >
        <Typography display="inline" noWrap={true} color="textPrimary">
          {title}
        </Typography>
      </Tooltip>

      <VehicleConditionIcon
        isInoperable={hasInoperable}
        transportType={transportType}
      />
    </Inline>
  );
}
